import {useEffect, useRef, useState} from 'react'
import styles from './index.module.less'
import classNames from "classnames";

const ResizeWidthWrap = (props: any) => {
  const {minWidth = 0, maxWidth = 500, width = 320, height = '100%'} = props

  const widthRef = useRef(width)
  const wrapRef = useRef<any>()

  const resizeRef = useRef<any>({
    startX: 0,
  })
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
  }, [])

  const handleResizeMouseDown = e => {
    e.preventDefault()
    resizeRef.current.startX = e.clientX
    document.addEventListener('mousemove', handleResizeMouseMove)
    document.addEventListener('mouseup', handleResizeMouseUp)
    setIsActive(true)
  }

  const handleResizeMouseMove = e => {
    e.preventDefault()
    const disX = e.clientX - resizeRef.current.startX
    const nextWidth = widthRef.current + disX
    // if (nextWidth > maxWidth) {
    //   nextWidth = maxWidth
    // } else if (nextWidth < minWidth) {
    //   nextWidth = minWidth
    // }
    wrapRef.current.style.width = nextWidth + 'px'
    // widthRef.current = nextWidth
  }

  const handleResizeMouseUp = () => {
    document.removeEventListener('mousemove', handleResizeMouseMove)
    document.removeEventListener('mouseup', handleResizeMouseUp)
    if (wrapRef.current) {
      widthRef.current = parseInt(getComputedStyle(wrapRef.current).width)
    }
    setIsActive(false)
  }

  return (
    <div style={{maxWidth: maxWidth, minWidth: minWidth, height: height, width: width}} ref={wrapRef}>
      {props.children}
      <div className={classNames(styles.resizeHandle, [isActive && styles.active])}
           onMouseDown={handleResizeMouseDown}/>
    </div>
  )
}

export default ResizeWidthWrap
